import { ActionParams } from './actions';
import { SaveFlowStatus } from '@src/types';

export const checkPendingChanges = ({ getState, setState }: ActionParams) => async () => {
  const { currentState, pendingState, saveState } = getState();

  const pendingChanges = JSON.stringify(currentState) !== JSON.stringify(pendingState);
  await setState({
    saveState: {
      ...saveState,
      pendingChanges,
    },
  });
};

export const setSaveStatus = ({ getState, setState }: ActionParams) => (status: SaveFlowStatus) => {
  const { saveState } = getState();
  setState({
    saveState: {
      ...saveState,
      status,
    },
  });
};
